module.exports = __webpack_public_path__ + "assets/img/fce0cc69f4b108c606033b37033cfd88.svg";